import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ObjectValue')
export class ListBoxItem {
  @JsonProperty('value', String, true)
  public value = '';

  @JsonProperty('label', String, true)
  public label = '';
}
